<div *ngIf="Image" class="image-container">
     <div>
          <img data-bs-toggle="modal"
          data-bs-target="#enLargeImageModal"
          [src]="'data:image/jpeg;base64,' + Image" 
          class="image-size"
          [alt]="ImageAltName" />
     </div>
</div>
<img *ngIf="!Image"
     src="default-image.png" 
     [alt]="ImageAltName" />
     
<!-- <ngx-skeleton-loader *ngIf="Loading != '0'" 
     count="1" 
     appearance="circle" 
     [theme]="{width: '100%', height: '150px', 'border-radius': '10px'}">
</ngx-skeleton-loader> -->

<!-- <app-enlarge-image-modal [enLargeImage]="Image" [enLargeImgTitle]="ImageTitle"></app-enlarge-image-modal> -->
